export { default as OneColumnStoreLocatorPage } from '../StoreLocatorCommonPage'
